const countries = [
  {
    code: "+7",
    name: "Russian Federation",
    flag: "🇷🇺",
    pattern: /^[0-9]{10}$/,
    mask: "000 000-00-00",
  },
  {
    code: "+49",
    name: "Germany",
    flag: "🇩🇪",
    pattern: /^[1-9]\d{4,14}$/,
    mask: "0000 0000000",
  },
  {
    code: "+994",
    name: "Azerbaijan",
    flag: "🇦🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 00 00",
  },
  {
    code: "+375",
    name: "Belarus",
    flag: "🇧🇾",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000-00-00",
  },
  {
    code: "+972",
    name: "Israel",
    flag: "🇮🇱",
    pattern: /^[2-9]\d{7,8}$/,
    mask: "000 000 000",
  },
  {
    code: "+380",
    name: "Ukraine",
    flag: "🇺🇦",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 00 00",
  },
  {
    code: "+20",
    name: "Egypt",
    flag: "🇪🇬",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+995",
    name: "Georgia",
    flag: "🇬🇪",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+374",
    name: "Armenia",
    flag: "🇦🇲",
    pattern: /^[49]\d{7}$/,
    mask: "00 000000",
  },
  {
    code: "+7",
    name: "Kazakhstan",
    flag: "🇰🇿",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000-00-00",
  },
  {
    code: "+61",
    name: "Australia",
    flag: "🇦🇺",
    pattern: /^[1-9]\d{8}$/,
    mask: "0 0000 0000",
  },
  {
    code: "+43",
    name: "Austria",
    flag: "🇦🇹",
    pattern: /^[1-9]\d{3,12}$/,
    mask: "0000 000000",
  },
  {
    code: "+355",
    name: "Albania",
    flag: "🇦🇱",
    pattern: /^[1-9]\d{7,9}$/,
    mask: "00 000 000",
  },
  {
    code: "+213",
    name: "Algeria",
    flag: "🇩🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+1 684",
    name: "American Samoa",
    flag: "🇦🇸",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+1 264",
    name: "Anguilla",
    flag: "🇦🇮",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+244",
    name: "Angola",
    flag: "🇦🇴",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+376",
    name: "Andorra",
    flag: "🇦🇩",
    pattern: /^[1-9]\d{5,7}$/,
    mask: "000 000",
  },
  {
    code: "+672",
    name: "Antarctica",
    flag: "🇦🇶",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+1 268",
    name: "Antigua and Barbuda",
    flag: "🇦🇬",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+54",
    name: "Argentina",
    flag: "🇦🇷",
    pattern: /^[1-9]\d{9}$/,
    mask: "00 0000 0000",
  },
  {
    code: "+297",
    name: "Aruba",
    flag: "🇦🇼",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+93",
    name: "Afghanistan",
    flag: "🇦🇫",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+1 242",
    name: "Bahamas",
    flag: "🇧🇸",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+880",
    name: "Bangladesh",
    flag: "🇧🇩",
    pattern: /^[1-9]\d{9}$/,
    mask: "00000 000000",
  },
  {
    code: "+1 246",
    name: "Barbados",
    flag: "🇧🇧",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+973",
    name: "Bahrain",
    flag: "🇧🇭",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+501",
    name: "Belize",
    flag: "🇧🇿",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+32",
    name: "Belgium",
    flag: "🇧🇪",
    pattern: /^[1-9]\d{7,8}$/,
    mask: "0000 0000",
  },
  {
    code: "+229",
    name: "Benin",
    flag: "🇧🇯",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+1 441",
    name: "Bermuda",
    flag: "🇧🇲",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+359",
    name: "Bulgaria",
    flag: "🇧🇬",
    pattern: /^[1-9]\d{7,8}$/,
    mask: "000 000 000",
  },
  {
    code: "+591",
    name: "Bolivia, plurinational state of",
    flag: "🇧🇴",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+599",
    name: "Bonaire, Sint Eustatius and Saba",
    flag: "🇧🇶",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+387",
    name: "Bosnia and Herzegovina",
    flag: "🇧🇦",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+267",
    name: "Botswana",
    flag: "🇧🇼",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+55",
    name: "Brazil",
    flag: "🇧🇷",
    pattern: /^[1-9]\d{9,10}$/,
    mask: "00 0000 0000",
  },
  {
    code: "+246",
    name: "British Indian Ocean Territory",
    flag: "🇮🇴",
    pattern: /^[1-9]\d{5}$/,
    mask: "000 000",
  },
  {
    code: "+673",
    name: "Brunei Darussalam",
    flag: "🇧🇳",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+226",
    name: "Burkina Faso",
    flag: "🇧🇫",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+257",
    name: "Burundi",
    flag: "🇧🇮",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+975",
    name: "Bhutan",
    flag: "🇧🇹",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+678",
    name: "Vanuatu",
    flag: "🇻🇺",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+36",
    name: "Hungary",
    flag: "🇭🇺",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+58",
    name: "Venezuela",
    flag: "🇻🇪",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 0000000",
  },
  {
    code: "+1 284",
    name: "Virgin Islands, British",
    flag: "🇻🇬",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+1 340",
    name: "Virgin Islands, U.S.",
    flag: "🇻🇮",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+84",
    name: "Vietnam",
    flag: "🇻🇳",
    pattern: /^[1-9]\d{8,9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+241",
    name: "Gabon",
    flag: "🇬🇦",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+509",
    name: "Haiti",
    flag: "🇭🇹",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+592",
    name: "Guyana",
    flag: "🇬🇾",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+220",
    name: "Gambia",
    flag: "🇬🇲",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+233",
    name: "Ghana",
    flag: "🇬🇭",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+590",
    name: "Guadeloupe",
    flag: "🇬🇵",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+502",
    name: "Guatemala",
    flag: "🇬🇹",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+224",
    name: "Guinea",
    flag: "🇬🇳",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+245",
    name: "Guinea-Bissau",
    flag: "🇬🇼",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+44",
    name: "Guernsey",
    flag: "🇬🇬",
    pattern: /^[1-9]\d{9}$/,
    mask: "0000 000000",
  },
  {
    code: "+350",
    name: "Gibraltar",
    flag: "🇬🇮",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+504",
    name: "Honduras",
    flag: "🇭🇳",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+852",
    name: "Hong Kong",
    flag: "🇭🇰",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+1 473",
    name: "Grenada",
    flag: "🇬🇩",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+299",
    name: "Greenland",
    flag: "🇬🇱",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 00 00",
  },
  {
    code: "+30",
    name: "Greece",
    flag: "🇬🇷",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+1 671",
    name: "Guam",
    flag: "🇬🇺",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+45",
    name: "Denmark",
    flag: "🇩🇰",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+44",
    name: "Jersey",
    flag: "🇯🇪",
    pattern: /^[1-9]\d{9}$/,
    mask: "0000 000000",
  },
  {
    code: "+253",
    name: "Djibouti",
    flag: "🇩🇯",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+1 767",
    name: "Dominica",
    flag: "🇩🇲",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+1 809",
    name: "Dominican Republic",
    flag: "🇩🇴",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+260",
    name: "Zambia",
    flag: "🇿🇲",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+212",
    name: "Western Sahara",
    flag: "🇪🇭",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 0000 000",
  },
  {
    code: "+263",
    name: "Zimbabwe",
    flag: "🇿🇼",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+91",
    name: "India",
    flag: "🇮🇳",
    pattern: /^[1-9]\d{9}$/,
    mask: "00000 00000",
  },
  {
    code: "+62",
    name: "Indonesia",
    flag: "🇮🇩",
    pattern: /^[1-9]\d{9,11}$/,
    mask: "000 0000 0000",
  },
  {
    code: "+962",
    name: "Jordan",
    flag: "🇯🇴",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+964",
    name: "Iraq",
    flag: "🇮🇶",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+98",
    name: "Iran, Islamic Republic of",
    flag: "🇮🇷",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+353",
    name: "Ireland",
    flag: "🇮🇪",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+354",
    name: "Iceland",
    flag: "🇮🇸",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+34",
    name: "Spain",
    flag: "🇪🇸",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+39",
    name: "Italy",
    flag: "🇮🇹",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+967",
    name: "Yemen",
    flag: "🇾🇪",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+238",
    name: "Cape Verde",
    flag: "🇨🇻",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+855",
    name: "Cambodia",
    flag: "🇰🇭",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+237",
    name: "Cameroon",
    flag: "🇨🇲",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+1",
    name: "Canada",
    flag: "🇨🇦",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+974",
    name: "Qatar",
    flag: "🇶🇦",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+254",
    name: "Kenya",
    flag: "🇰🇪",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000000",
  },
  {
    code: "+357",
    name: "Cyprus",
    flag: "🇨🇾",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000000",
  },
  {
    code: "+996",
    name: "Kyrgyzstan",
    flag: "🇰🇬",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+686",
    name: "Kiribati",
    flag: "🇰🇮",
    pattern: /^[1-9]\d{4}$/,
    mask: "00 000",
  },
  {
    code: "+86",
    name: "China",
    flag: "🇨🇳",
    pattern: /^[1-9]\d{10}$/,
    mask: "000 0000 0000",
  },
  {
    code: "+61",
    name: "Cocos (Keeling) Islands",
    flag: "🇨🇨",
    pattern: /^[1-9]\d{8}$/,
    mask: "0 0000 0000",
  },
  {
    code: "+57",
    name: "Colombia",
    flag: "🇨🇴",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+269",
    name: "Comoros",
    flag: "🇰🇲",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+242",
    name: "Congo",
    flag: "🇨🇬",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+243",
    name: "Congo, Democratic Republic of the",
    flag: "🇨🇩",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+850",
    name: "Korea, Democratic People's republic of",
    flag: "🇰🇵",
    pattern: /^[1-9]\d{7}$/,
    mask: "000 000 00",
  },
  {
    code: "+82",
    name: "Korea, Republic of",
    flag: "🇰🇷",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 0000 0000",
  },
  {
    code: "+506",
    name: "Costa Rica",
    flag: "🇨🇷",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+225",
    name: "Cote d'Ivoire",
    flag: "🇨🇮",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+53",
    name: "Cuba",
    flag: "🇨🇺",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000000",
  },
  {
    code: "+965",
    name: "Kuwait",
    flag: "🇰🇼",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+599",
    name: "Curaçao",
    flag: "🇨🇼",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+856",
    name: "Lao People's Democratic Republic",
    flag: "🇱🇦",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+371",
    name: "Latvia",
    flag: "🇱🇻",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+266",
    name: "Lesotho",
    flag: "🇱🇸",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+961",
    name: "Lebanon",
    flag: "🇱🇧",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+218",
    name: "Libyan Arab Jamahiriya",
    flag: "🇱🇾",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+231",
    name: "Liberia",
    flag: "🇱🇷",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+423",
    name: "Liechtenstein",
    flag: "🇱🇮",
    pattern: /^[1-9]\d{7}$/,
    mask: "000 000 00",
  },
  {
    code: "+370",
    name: "Lithuania",
    flag: "🇱🇹",
    pattern: /^[1-9]\d{7}$/,
    mask: "000 00000",
  },
  {
    code: "+352",
    name: "Luxembourg",
    flag: "🇱🇺",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+230",
    name: "Mauritius",
    flag: "🇲🇺",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+222",
    name: "Mauritania",
    flag: "🇲🇷",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+261",
    name: "Madagascar",
    flag: "🇲🇬",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 00 000 00",
  },
  {
    code: "+262",
    name: "Mayotte",
    flag: "🇾🇹",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+853",
    name: "Macao",
    flag: "🇲🇴",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+265",
    name: "Malawi",
    flag: "🇲🇼",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+60",
    name: "Malaysia",
    flag: "🇲🇾",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+223",
    name: "Mali",
    flag: "🇲🇱",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+1",
    name: "United States Minor Outlying Islands",
    flag: "🇺🇲",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+960",
    name: "Maldives",
    flag: "🇲🇻",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+356",
    name: "Malta",
    flag: "🇲🇹",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+212",
    name: "Morocco",
    flag: "🇲🇦",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 0000 000",
  },
  {
    code: "+596",
    name: "Martinique",
    flag: "🇲🇶",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+692",
    name: "Marshall Islands",
    flag: "🇲🇭",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+52",
    name: "Mexico",
    flag: "🇲🇽",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+691",
    name: "Micronesia, Federated States of",
    flag: "🇫🇲",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+258",
    name: "Mozambique",
    flag: "🇲🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+373",
    name: "Moldova",
    flag: "🇲🇩",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+377",
    name: "Monaco",
    flag: "🇲🇨",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+976",
    name: "Mongolia",
    flag: "🇲🇳",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+1 664",
    name: "Montserrat",
    flag: "🇲🇸",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+95",
    name: "Burma",
    flag: "🇲🇲",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+264",
    name: "Namibia",
    flag: "🇳🇦",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+674",
    name: "Nauru",
    flag: "🇳🇷",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+977",
    name: "Nepal",
    flag: "🇳🇵",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+227",
    name: "Niger",
    flag: "🇳🇪",
    pattern: /^[1-9]\d{7}$/,
    mask: "00",
  },
  {
    code: "+234",
    name: "Nigeria",
    flag: "🇳🇬",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+31",
    name: "Netherlands",
    flag: "🇳🇱",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+505",
    name: "Nicaragua",
    flag: "🇳🇮",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+683",
    name: "Niue",
    flag: "🇳🇺",
    pattern: /^[1-9]\d{4}$/,
    mask: "00 000",
  },
  {
    code: "+64",
    name: "New Zealand",
    flag: "🇳🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+687",
    name: "New Caledonia",
    flag: "🇳🇨",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+47",
    name: "Norway",
    flag: "🇳🇴",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+971",
    name: "UAE (Dubai)",
    flag: "🇦🇪",
    pattern: /^[569]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+968",
    name: "Oman",
    flag: "🇴🇲",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+47",
    name: "Bouvet Island",
    flag: "🇧🇻",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+44",
    name: "Isle of Man",
    flag: "🇮🇲",
    pattern: /^[1-9]\d{9}$/,
    mask: "0000 000000",
  },
  {
    code: "+672",
    name: "Norfolk Island",
    flag: "🇳🇫",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+61",
    name: "Christmas Island",
    flag: "🇨🇽",
    pattern: /^[1-9]\d{8}$/,
    mask: "0 0000 0000",
  },
  {
    code: "+672",
    name: "Heard Island and McDonald Islands",
    flag: "🇭🇲",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+1 345",
    name: "Cayman Islands",
    flag: "🇰🇾",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+682",
    name: "Cook Islands",
    flag: "🇨🇰",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 000",
  },
  {
    code: "+1 649",
    name: "Turks and Caicos Islands",
    flag: "🇹🇨",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+92",
    name: "Pakistan",
    flag: "🇵🇰",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 0000000",
  },
  {
    code: "+680",
    name: "Palau",
    flag: "🇵🇼",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+970",
    name: "Palestinian Territory, Occupied",
    flag: "🇵🇸",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+507",
    name: "Panama",
    flag: "🇵🇦",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+379",
    name: "Holy See (Vatican City State)",
    flag: "🇻🇦",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+675",
    name: "Papua New Guinea",
    flag: "🇵🇬",
    pattern: /^[1-9]\d{7}$/,
    mask: "000 00000",
  },
  {
    code: "+595",
    name: "Paraguay",
    flag: "🇵🇾",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+51",
    name: "Peru",
    flag: "🇵🇪",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+64",
    name: "Pitcairn",
    flag: "🇵🇳",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+48",
    name: "Poland",
    flag: "🇵🇱",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+351",
    name: "Portugal",
    flag: "🇵🇹",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+1 787",
    name: "Puerto Rico",
    flag: "🇵🇷",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+389",
    name: "Macedonia, The Former Yugoslav Republic Of",
    flag: "🇲🇰",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+262",
    name: "Reunion",
    flag: "🇷🇪",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+250",
    name: "Rwanda",
    flag: "🇷🇼",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+40",
    name: "Romania",
    flag: "🇷🇴",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+685",
    name: "Samoa",
    flag: "🇼🇸",
    pattern: /^[1-9]\d{6}$/,
    mask: "00 00000",
  },
  {
    code: "+378",
    name: "San Marino",
    flag: "🇸🇲",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+239",
    name: "Sao Tome and Principe",
    flag: "🇸🇹",
    pattern: /^[1-9]\d{6}$/,
    mask: "00 00000",
  },
  {
    code: "+966",
    name: "Saudi Arabia",
    flag: "🇸🇦",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+268",
    name: "Swaziland",
    flag: "🇸🇿",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+290",
    name: "Saint Helena, Ascension And Tristan Da Cunha",
    flag: "🇸🇭",
    pattern: /^[1-9]\d{4}$/,
    mask: "00 000",
  },
  {
    code: "+1 670",
    name: "Northern Mariana Islands",
    flag: "🇲🇵",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+590",
    name: "Saint Barthélemy",
    flag: "🇧🇱",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+590",
    name: "Saint Martin (French Part)",
    flag: "🇲🇫",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+221",
    name: "Senegal",
    flag: "🇸🇳",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+1 784",
    name: "Saint Vincent and the Grenadines",
    flag: "🇻🇨",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+1 869",
    name: "Saint Kitts and Nevis",
    flag: "🇰🇳",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+1 758",
    name: "Saint Lucia",
    flag: "🇱🇨",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+508",
    name: "Saint Pierre and Miquelon",
    flag: "🇵🇲",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 00 00",
  },
  {
    code: "+381",
    name: "Serbia",
    flag: "🇷🇸",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+248",
    name: "Seychelles",
    flag: "🇸🇨",
    pattern: /^[1-9]\d{6}$/,
    mask: "0 000 000",
  },
  {
    code: "+65",
    name: "Singapore",
    flag: "🇸🇬",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+1 721",
    name: "Sint Maarten",
    flag: "🇸🇽",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+963",
    name: "Syrian Arab Republic",
    flag: "🇸🇾",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 0000 000",
  },
  {
    code: "+421",
    name: "Slovakia",
    flag: "🇸🇰",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+386",
    name: "Slovenia",
    flag: "🇸🇮",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+44",
    name: "United Kingdom",
    flag: "🇬🇧",
    pattern: /^[1-9]\d{9}$/,
    mask: "0000 000000",
  },
  {
    code: "+1",
    name: "United States",
    flag: "🇺🇸",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+677",
    name: "Solomon Islands",
    flag: "🇸🇧",
    pattern: /^[1-9]\d{6}$/,
    mask: "00 00000",
  },
  {
    code: "+252",
    name: "Somalia",
    flag: "🇸🇴",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000000",
  },
  {
    code: "+249",
    name: "Sudan",
    flag: "🇸🇩",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+597",
    name: "Suriname",
    flag: "🇸🇷",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+232",
    name: "Sierra Leone",
    flag: "🇸🇱",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000000",
  },
  {
    code: "+992",
    name: "Tajikistan",
    flag: "🇹🇯",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+66",
    name: "Thailand",
    flag: "🇹🇭",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+886",
    name: "Taiwan, Province of China",
    flag: "🇹🇼",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 0000 0000",
  },
  {
    code: "+255",
    name: "Tanzania, United Republic Of",
    flag: "🇹🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+670",
    name: "Timor-Leste",
    flag: "🇹🇱",
    pattern: /^[1-9]\d{7}$/,
    mask: "000 00000",
  },
  {
    code: "+228",
    name: "Togo",
    flag: "🇹🇬",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+690",
    name: "Tokelau",
    flag: "🇹🇰",
    pattern: /^[1-9]\d{4}$/,
    mask: "00 000",
  },
  {
    code: "+676",
    name: "Tonga",
    flag: "🇹🇴",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+1 868",
    name: "Trinidad and Tobago",
    flag: "🇹🇹",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+688",
    name: "Tuvalu",
    flag: "🇹🇻",
    pattern: /^[1-9]\d{5}$/,
    mask: "00 0000",
  },
  {
    code: "+216",
    name: "Tunisia",
    flag: "🇹🇳",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+993",
    name: "Turkmenistan",
    flag: "🇹🇲",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000000",
  },
  {
    code: "+90",
    name: "Turkey",
    flag: "🇹🇷",
    pattern: /^[1-9]\d{9}$/,
    mask: "000 000 0000",
  },
  {
    code: "+256",
    name: "Uganda",
    flag: "🇺🇬",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+998",
    name: "Uzbekistan",
    flag: "🇺🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+996",
    name: "Kirghizia",
    flag: "🇰🇬",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+373",
    name: "Moldavia",
    flag: "🇲🇩",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+689",
    name: "French Polynesia",
    flag: "🇵🇫",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+262",
    name: "French Southern Territories",
    flag: "🇹🇫",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+385",
    name: "Croatia",
    flag: "🇭🇷",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+236",
    name: "Central African Republic",
    flag: "🇨🇫",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+235",
    name: "Chad",
    flag: "🇹🇩",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 0000",
  },
  {
    code: "+382",
    name: "Montenegro",
    flag: "🇲🇪",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+420",
    name: "Czech Republic",
    flag: "🇨🇿",
    pattern: /^[1-9]\d{8}$/,
    mask: "000 000 000",
  },
  {
    code: "+56",
    name: "Chile",
    flag: "🇨🇱",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 0000 0000",
  },
  {
    code: "+41",
    name: "Switzerland",
    flag: "🇨🇭",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 00 00",
  },
  {
    code: "+46",
    name: "Sweden",
    flag: "🇸🇪",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 0000",
  },
  {
    code: "+47",
    name: "Svalbard and Jan Mayen",
    flag: "🇸🇯",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 00 00 00",
  },
  {
    code: "+94",
    name: "Sri Lanka",
    flag: "🇱🇰",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+593",
    name: "Ecuador",
    flag: "🇪🇨",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+240",
    name: "Equatorial Guinea",
    flag: "🇬🇶",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+358",
    name: "Aland Islands",
    flag: "🇦🇽",
    pattern: /^[1-9]\d{7}$/,
    mask: "00 000 000",
  },
  {
    code: "+503",
    name: "El Salvador",
    flag: "🇸🇻",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+291",
    name: "Eritrea",
    flag: "🇪🇷",
    pattern: /^[1-9]\d{6}$/,
    mask: "00 000 000",
  },
  {
    code: "+372",
    name: "Estonia",
    flag: "🇪🇪",
    pattern: /^[1-9]\d{7}$/,
    mask: "0000 0000",
  },
  {
    code: "+251",
    name: "Ethiopia",
    flag: "🇪🇹",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+27",
    name: "South Africa",
    flag: "🇿🇦",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+500",
    name: "South Georgia and the South Sandwich Islands",
    flag: "🇬🇸",
    pattern: /^[1-9]\d{4}$/,
    mask: "00 000",
  },
  // {
  //   code: "+995 34",
  //   name: "South Ossetia",
  //   flag: "🇴🇸",
  //   pattern: /^[1-9]\d{7}$/,
  //   mask: "00 000 000",
  // },
  {
    code: "+211",
    name: "South Sudan",
    flag: "🇸🇸",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 000 0000",
  },
  {
    code: "+1 876",
    name: "Jamaica",
    flag: "🇯🇲",
    pattern: /^[1-9]\d{6}$/,
    mask: "000 0000",
  },
  {
    code: "+81",
    name: "Japan",
    flag: "🇯🇵",
    pattern: /^[1-9]\d{8}$/,
    mask: "00 0000 0000",
  },
]

export default countries
